import { render, staticRenderFns } from "./LomEventsReport.vue?vue&type=template&id=245b2f98"
import script from "./LomEventsReport.vue?vue&type=script&lang=js"
export * from "./LomEventsReport.vue?vue&type=script&lang=js"
import style0 from "./LomEventsReport.vue?vue&type=style&index=0&id=245b2f98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports